const gigListings = [
	{
		path: '/jobs/gig-listings/list',
		name: 'jobs-gig-listings-list',
		component: () => import('@/views/jobs/gig-listings/list.vue'),
		meta: { layout: 'content', module: 'MGJ,gigs' },
	},
]

export default gigListings
